import * as React from 'react';
import { WidgetWrapper } from '../core/DashbardGridStyledComponents';
const randomStr = (len: any, arr: string | any[]) => {
  var ans = '';
  for (let i = len; i > 0; i--) {
    ans += arr[Math.floor(Math.random() * arr.length)];
  }
  return ans;
};

/**
 * Zoid Widget
 * @param data details of the cross domain config tag, url, dimensions, props
 */
export const ZoidWidgetRenderer: React.FC<any> = React.memo(
  ({ view, data, ...props }) => {
    const { component } = view;
    const { values } = data;
    const [divId, setDivId] = React.useState('');
    React.useEffect(() => {
      const divId = `zoid-${randomStr(10, '1234abcdefgh')}`;
      setDivId(divId);
    }, [data]);

    React.useEffect(() => {
      if (divId.length > 0) {
        component({ ...values }).render(`#${divId}`);
      }
    }, [divId]);

    const createDiv = () => {
      if (divId === '') return <></>;
      let domElement = document.getElementById(divId);
      if (!domElement) {
        return React.createElement('div', { id: divId });
      }
      return <></>;
    };
    return <WidgetWrapper {...props}>{createDiv()}</WidgetWrapper>;
  }
);
